module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLight.38bc5e0.ttf";